import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const ServicePageWrapper = styled.div`
  padding-top: 120px;
  min-height: 100vh;
  background: #fff;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 80px;
`;

const PageTitle = styled.h1`
  font-size: 3rem;
  color: var(--text-dark);
  margin-bottom: 20px;
  font-family: "Phudu", sans-serif;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const PageSubtitle = styled.p`
  font-size: 1.2rem;
  color: var(--text-light);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  margin-bottom: 80px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const ContentSection = styled.div`
  h2 {
    font-size: 2rem;
    color: var(--text-dark);
    margin-bottom: 20px;
    font-family: "Phudu", sans-serif;
  }

  p {
    color: var(--text-light);
    line-height: 1.6;
    margin-bottom: 20px;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      color: var(--text-light);
      padding: 10px 0;
      border-bottom: 1px solid #f0f0f0;

      &:before {
        content: "✓";
        color: var(--secondary-color);
        font-weight: bold;
        margin-right: 10px;
      }
    }
  }
`;

const ImageSection = styled.div`
  img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 20px;
  }
`;

const SizeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin: 60px 0;
`;

const SizeCard = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  text-align: center;

  h3 {
    font-size: 1.5rem;
    color: var(--text-dark);
    margin-bottom: 15px;
    font-family: "Phudu", sans-serif;
  }

  p {
    color: var(--text-light);
    margin-bottom: 20px;
  }

  .price {
    font-size: 1.25rem;
    color: var(--secondary-color);
    font-weight: bold;
  }
`;

const CTASection = styled.div`
  background: var(--background-dark);
  color: white;
  padding: 60px 40px;
  border-radius: 20px;
  text-align: center;
  margin-bottom: 80px;

  h2 {
    font-size: 2rem;
    margin-bottom: 20px;
    font-family: "Phudu", sans-serif;
  }

  p {
    margin-bottom: 30px;
    opacity: 0.9;
  }

  .btn {
    background: var(--secondary-color);
    color: white;
    padding: 15px 30px;
    border-radius: 10px;
    text-decoration: none;
    font-weight: 600;
    display: inline-block;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 20px rgba(245, 115, 58, 0.3);
    }
  }
`;

const NewContainers = () => {
  return (
    <ServicePageWrapper>
      <Container>
        <PageHeader>
          <PageTitle>New Containers</PageTitle>
          <PageSubtitle>
            Brand new, one-trip containers perfect for long-term use. Clean,
            rust-free, and ready for immediate deployment.
          </PageSubtitle>
        </PageHeader>

        <ContentGrid>
          <ContentSection>
            <h2>Premium New Containers</h2>
            <p>
              Our new containers are manufactured to the highest standards and
              have only made one trip from the factory. They offer the best
              value for customers who need reliable, long-term storage
              solutions.
            </p>
            <p>
              Perfect for businesses, construction sites, and residential
              projects that require clean, secure storage with maximum
              durability.
            </p>
            <ul>
              <li>One-trip containers - minimal wear and tear</li>
              <li>Wind and watertight certification</li>
              <li>Clean interior with minimal odor</li>
              <li>Fresh paint and minimal surface rust</li>
              <li>Optimal for long-term storage solutions</li>
              <li>Available in multiple sizes</li>
            </ul>
          </ContentSection>

          <ImageSection>
            <img src="/assets/2025/08/Image2.jpg" alt="New Container" />
          </ImageSection>
        </ContentGrid>

        <SizeGrid>
          <SizeCard>
            <h3>10ft Container</h3>
            <p>Perfect for smaller storage needs or tight spaces</p>
            <div className="price">Starting at $1,500</div>
          </SizeCard>
          <SizeCard>
            <h3>20ft Container</h3>
            <p>Most popular size for residential and commercial use</p>
            <div className="price">Starting at $2,000</div>
          </SizeCard>
          <SizeCard>
            <h3>40ft Container</h3>
            <p>Maximum storage capacity for large-scale needs</p>
            <div className="price">Starting at $3,200</div>
          </SizeCard>
          <SizeCard>
            <h3>40ft High Cube</h3>
            <p>Extra height for oversized items and equipment</p>
            <div className="price">Starting at $7,000</div>
          </SizeCard>
        </SizeGrid>

        <CTASection>
          <h2>Ready to Get Started?</h2>
          <p>
            Contact us today for a custom quote on new containers. We offer
            competitive pricing and nationwide delivery.
          </p>
          <Link to="/contact" className="btn">
            Get Quote Now
          </Link>
        </CTASection>
      </Container>
    </ServicePageWrapper>
  );
};

export default NewContainers;
